var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 97.248C492.96 105.6 472.672 111.136 451.52 113.824C473.28 100.832 489.888 80.416 497.696 55.808C477.408 67.904 455.008 76.448 431.136 81.216C411.872 60.704 384.416 48 354.464 48C296.352 48 249.568 95.168 249.568 152.992C249.568 161.312 250.272 169.312 252 176.928C164.736 172.672 87.52 130.848 35.648 67.136C26.592 82.848 21.28 100.832 21.28 120.192C21.28 156.544 40 188.768 67.904 207.424C51.04 207.104 34.496 202.208 20.48 194.496C20.48 194.816 20.48 195.232 20.48 195.648C20.48 246.656 56.864 289.024 104.576 298.784C96.032 301.12 86.72 302.24 77.056 302.24C70.336 302.24 63.552 301.856 57.184 300.448C70.784 342.016 109.376 372.576 155.264 373.568C119.552 401.504 74.208 418.336 25.12 418.336C16.512 418.336 8.256 417.952 0 416.896C46.496 446.88 101.6 464 161.024 464C354.176 464 459.776 304 459.776 165.312C459.776 160.672 459.616 156.192 459.392 151.744C480.224 136.96 497.728 118.496 512 97.248Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a22e81589c415d17a82743471eeafdb1.svg";
export { ForwardRef as ReactComponent };